
export default {
    name: "OXOMI",
    mounted() {
        const locale = this.$i18n.locale
        const query = this.$route?.query?.search

        const script = document.createElement("script")
        script.type = "text/javascript"
        script.async = true
        script.src = "https://oxomi.com/assets/frontend/v2/oxomi.js"
        document.head.appendChild(script)

        document.addEventListener("oxomi-loaded", () => {
            oxomi.init({
                portal: "2024579",
                lang: locale,
                filterLang: locale,
            })
        })

        document.addEventListener("oxomi-configured", () => {
            oxomi.universalSearch({
                target: "#oxomi-output",
                showFilterBox: true,
                showFilterBar: false,
                showActions: true,
                hiddenContentLanguage: locale,
                filterBoxGroups: "contentType",
                query,
            })
        })
    }
}
